import React from "react";
import { classNames } from "src/helpers/classNames";

const MultiRowSelectContainer = ({ disabled = true, children }) => {
  return <div className={classNames("py-1 bg-gray-50/80 rounded-full px-2 ml-3 flex items-center gap-x-1 transition-all duration-200", disabled ? "cursor-not-allowed opacity-40 overflow-x-hidden" : "max-w-[400px] opacity-100")}>{children}</div>;
};

export default MultiRowSelectContainer;
